/* Custom Sizing (BTR) - source notes in project docs */
(function () {
  'use strict';
  if (window.__mtmLoaded) return;
  window.__mtmLoaded = true;
  var routes = window.routes || {};
  var ROOT = routes.rootUrlWithoutSlash || '';
  var CART_ADD = (routes.cartAddUrl || ROOT + '/cart/add') + '.js';
  var CART_UPDATE = ROOT + '/cart/update.js';
  var CART_JS = ROOT + '/cart.js';
  var CART_URL = routes.cartUrl || ROOT + '/cart';
  var FEE_ID = Number(window.MTM_FEE_VARIANT_ID) || null;
  var CHANGE_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var nativeFetch = window.fetch.bind(window);
  var state = (window.MTM_STATE = window.MTM_STATE || {});
  function getState(formId) {
    if (!state[formId]) state[formId] = { active: false, values: {} };
    return state[formId];
  }
  function postJSON(url, body) {
    return nativeFetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });
  }
  function parseJSON(el) {
    try {
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      return null;
    }
  }
  function getSizeOption(form) {
    if (!form) return null;
    var options = form.querySelectorAll('.product-form__option');
    for (var i = 0; i < options.length; i++) {
      var name = options[i].querySelector('.product-form__option-name');
      if (name && /^\s*size/i.test(name.textContent)) return options[i];
    }
    return null;
  }
  function getCurrentVariant(form) {
    return parseJSON(form.querySelector('script[data-variant]'));
  }
  function getProductData(form) {
    return parseJSON(form.querySelector('script[data-mtm-product]')) || { sizeIndex: -1, variants: [] };
  }
  function findBaseVariant(form) {
    var data = getProductData(form);
    var current = getCurrentVariant(form);
    var sizeIndex = data.sizeIndex;
    if (!current || sizeIndex < 0) return current && current.available ? current : null;
    var sameOptions = data.variants.filter(function (variant) {
      for (var j = 0; j < variant.options.length; j++) {
        if (j !== sizeIndex && variant.options[j] !== current.options[j]) return false;
      }
      return true;
    });
    return sameOptions.filter(function (variant) {
      return variant.available;
    })[0] || null;
  }
  function optionsWithoutSize(form, variant) {
    var sizeIndex = getProductData(form).sizeIndex;
    return (variant.options || []).filter(function (value, index) {
      return index !== sizeIndex && value !== 'Default Title';
    }).join(' / ');
  }
  function setFieldError(input, on) {
    var field = input.closest('.mtm__field');
    if (field) field.classList.toggle('is-error', !!on);
  }
  function getUnit(panel) {
    var checked = panel.querySelector('[data-mtm-unit]:checked');
    return checked ? checked.value : 'in';
  }
  function updateProgress(panel) {
    var required = panel.querySelectorAll('[data-mtm-required]');
    var done = 0;
    for (var i = 0; i < required.length; i++) if (required[i].value.trim()) done++;
    var bar = panel.querySelector('[data-mtm-bar]');
    var count = panel.querySelector('[data-mtm-count]');
    if (bar) bar.style.width = (required.length ? (done / required.length) * 100 : 0) + '%';
    if (count) count.textContent = done === required.length ? 'All set, add to cart below' : done + ' of ' + required.length + ' measurements done';
  }
  function showPanelError(panel, message) {
    var el = panel.querySelector('.mtm__error');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }
  function applyUI(form) {
    if (!form || !form.id) return;
    var s = getState(form.id);
    var toggle = form.querySelector('mtm-toggle');
    var panel = form.querySelector('mtm-panel');
    var label = (toggle && toggle.getAttribute('data-label')) || (panel && panel.getAttribute('data-label')) || 'Custom Sizing';
    form.classList.toggle('mtm-active', s.active);
    if (toggle) {
      var button = toggle.querySelector('button');
      if (button) {
        button.classList.toggle('is-active', s.active);
        button.setAttribute('aria-pressed', s.active ? 'true' : 'false');
      }
    }
    if (panel) {
      panel.hidden = !s.active;
      var inputs = panel.querySelectorAll('[data-mtm-input]');
      for (var i = 0; i < inputs.length; i++) inputs[i].disabled = !s.active;
      if (!s.active) showPanelError(panel, '');
    }
    var sizeOption = getSizeOption(form);
    if (sizeOption) {
      sizeOption.classList.toggle('mtm-size-muted', s.active);
      sizeOption.setAttribute('aria-disabled', s.active ? 'true' : 'false');
      var selected = sizeOption.querySelector('.product-form__selected-value');
      if (selected) {
        if (s.active) {
          if (!selected.hasAttribute('data-mtm-original')) selected.setAttribute('data-mtm-original', selected.textContent);
          selected.textContent = label;
        } else if (selected.hasAttribute('data-mtm-original')) {
          selected.textContent = selected.getAttribute('data-mtm-original');
          selected.removeAttribute('data-mtm-original');
        }
      }
    }
  }
  function setActive(form, active) {
    getState(form.id).active = active;
    applyUI(form);
  }
  function blockSizeWhileActive(event) {
    var option = event.target.closest && event.target.closest('.product-form__option');
    if (!option) return;
    var form = option.closest('form');
    if (!form || !form.id || !state[form.id] || !state[form.id].active) return;
    if (getSizeOption(form) !== option) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  document.addEventListener('click', blockSizeWhileActive, true);
  document.addEventListener('keydown', blockSizeWhileActive, true);
  class MtmToggle extends HTMLElement {
    connectedCallback() {
      var form = this.closest('form');
      if (!form) return;
      if (!this._bound) {
        this._bound = true;
        this.querySelector('button').addEventListener('click', function (event) {
          event.preventDefault();
          var f = this.closest('form');
          var active = !getState(f.id).active;
          setActive(f, active);
          if (active) {
            var panel = f.querySelector('mtm-panel');
            if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }.bind(this));
      }
      applyUI(form);
    }
  }
  class MtmPanel extends HTMLElement {
    connectedCallback() {
      var form = this.closest('form');
      if (!form) return;
      var panel = this;
      var s = getState(form.id);
      var inputs = this.querySelectorAll('[data-mtm-input]');
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input.type === 'hidden') continue;
        if (s.values[input.name] != null) input.value = s.values[input.name];
        if (!input._mtmBound) {
          input._mtmBound = true;
          input.addEventListener('input', function (event) {
            var f = event.target.closest('form');
            if (f) getState(f.id).values[event.target.name] = event.target.value;
            setFieldError(event.target, false);
            updateProgress(panel);
          });
        }
      }
      var units = this.querySelectorAll('[data-mtm-unit]');
      var setUnit = function (unit) {
        s.unit = unit;
        var labels = panel.querySelectorAll('[data-mtm-unit-label]');
        for (var k = 0; k < labels.length; k++) labels[k].textContent = unit;
      };
      for (var u = 0; u < units.length; u++) {
        if (s.unit) units[u].checked = units[u].value === s.unit;
        units[u].addEventListener('change', function (event) {
          setUnit(event.target.value);
        });
      }
      setUnit(getUnit(panel));
      updateProgress(panel);
      applyUI(form);
    }
  }
  if (!customElements.get('mtm-toggle')) customElements.define('mtm-toggle', MtmToggle);
  if (!customElements.get('mtm-panel')) customElements.define('mtm-panel', MtmPanel);
  var adding = false;
  function validate(panel) {
    var first = null;
    var required = panel.querySelectorAll('[data-mtm-required]');
    for (var i = 0; i < required.length; i++) {
      var empty = !required[i].value.trim();
      setFieldError(required[i], empty);
      if (empty && !first) first = required[i];
    }
    if (first) {
      showPanelError(panel, 'Fill in the highlighted measurements to add Custom Sizing.');
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      first.focus({ preventScroll: true });
      return false;
    }
    showPanelError(panel, '');
    return true;
  }
  function addToCart(form, panel, button) {
    var base = findBaseVariant(form);
    if (!base) {
      showPanelError(panel, 'Custom Sizing is currently unavailable for this color. Please call us.');
      return;
    }
    adding = true;
    var formData = new FormData(form);
    var variantId = Number(base.id);
    var quantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
    var feeId = Number(panel.getAttribute('data-fee-variant')) || FEE_ID;
    var key = 'MTM-' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 6).toUpperCase();
    var properties = {};
    var unit = getUnit(panel);
    var measures = {};
    var measureInputs = panel.querySelectorAll('[data-mtm-measure]');
    for (var m = 0; m < measureInputs.length; m++) measures[measureInputs[m].name] = true;
    formData.forEach(function (value, name) {
      var match = name.match(/^properties\[(.+)\]$/);
      if (!match || typeof value !== 'string' || value.trim() === '') return;
      properties[match[1]] = value.trim() + (measures[name] ? ' ' + unit : '');
    });
    properties._mtm_key = key;
    properties._mtm_fee = String(feeId);
    var forText = panel.getAttribute('data-product-title') || '';
    var options = optionsWithoutSize(form, base);
    if (options) forText += ' - ' + options;
    var items = [
      { id: variantId, quantity: quantity, properties: properties },
      { id: feeId, quantity: quantity, properties: { For: forText, _mtm_for: key } }
    ];
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    showPanelError(panel, '');
    postJSON(CART_ADD, { items: items })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) throw new Error(result.data.description || result.data.message || 'Sorry, this item could not be added to your cart.');
        if (window.theme && window.theme.cartType === 'page') {
          window.location.href = CART_URL;
          return;
        }
        var added = (result.data.items || []).filter(function (item) {
          return item.variant_id === variantId;
        })[0] || (result.data.items || [])[0];
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: added, quantity: quantity * 2 }
        }));
      })
      .catch(function (error) {
        showPanelError(panel, error.message);
      })
      .finally(function () {
        adding = false;
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
  }
  function interceptAdd(event) {
    var form = null;
    var button = null;
    if (event.type === 'submit') {
      form = event.target;
    } else {
      button = event.target.closest && event.target.closest('button[type="submit"], .product-form__add-button');
      if (!button || button.name === 'checkout') return;
      form = button.form || button.closest('form');
    }
    if (!form || !form.id || !state[form.id] || !state[form.id].active) return;
    var panel = form.querySelector('mtm-panel');
    if (!panel) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (adding) return;
    if (!validate(panel)) return;
    addToCart(form, panel, button || form.querySelector('.product-form__add-button'));
  }
  document.addEventListener('click', interceptAdd, true);
  document.addEventListener('submit', interceptAdd, true);
  var syncTimer = null;
  var syncing = false;
  var syncAgain = false;
  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, delay == null ? 350 : delay);
  }
  function markFeeLines(cart) {
    cart.items.forEach(function (item, index) {
      var props = item.properties || {};
      if (!props._mtm_for) return;
      var links = document.querySelectorAll('.line-item__quantity-remove[data-line="' + (index + 1) + '"]');
      for (var i = 0; i < links.length; i++) links[i].style.display = 'none';
    });
  }
  function afterChange() {
    if (window.theme && window.theme.pageType === 'cart') {
      window.location.reload();
      return;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }
  function sync() {
    if (syncing) {
      syncAgain = true;
      return;
    }
    syncing = true;
    nativeFetch(CART_JS, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var needed = {};
        var info = {};
        var seen = {};
        var updates = {};
        var adds = [];
        cart.items.forEach(function (item) {
          var props = item.properties || {};
          if (props._mtm_key && !props._mtm_for) {
            needed[props._mtm_key] = (needed[props._mtm_key] || 0) + item.quantity;
            info[props._mtm_key] = { fee: Number(props._mtm_fee) || FEE_ID, title: item.product_title };
          }
        });
        cart.items.forEach(function (item) {
          var props = item.properties || {};
          if (!props._mtm_for) {
            if (FEE_ID && item.variant_id === FEE_ID) updates[item.key] = 0;
            return;
          }
          var target = seen[props._mtm_for] ? 0 : needed[props._mtm_for] || 0;
          seen[props._mtm_for] = true;
          if (item.quantity !== target) updates[item.key] = target;
        });
        Object.keys(needed).forEach(function (key) {
          if (!seen[key] && info[key].fee) {
            adds.push({ id: info[key].fee, quantity: needed[key], properties: { For: info[key].title, _mtm_for: key } });
          }
        });
        var changed = false;
        var chain = Promise.resolve();
        if (Object.keys(updates).length) {
          chain = chain.then(function () {
            return postJSON(CART_UPDATE, { updates: updates }).then(function (response) {
              if (response.ok) changed = true;
            });
          });
        }
        if (adds.length) {
          chain = chain.then(function () {
            return postJSON(CART_ADD, { items: adds }).then(function (response) {
              if (response.ok) changed = true;
            });
          });
        }
        return chain.then(function () {
          if (changed) {
            afterChange();
          } else {
            markFeeLines(cart);
          }
        });
      })
      .catch(function () {})
      .finally(function () {
        syncing = false;
        if (syncAgain) {
          syncAgain = false;
          scheduleSync(0);
        }
      });
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var request = nativeFetch(input, init);
    if (CHANGE_RE.test(url)) {
      request.then(function () {
        scheduleSync();
      }, function () {});
    }
    return request;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._mtmUrl = url;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (CHANGE_RE.test(String(this._mtmUrl || ''))) {
      this.addEventListener('loadend', function () {
        scheduleSync();
      });
    }
    return xhrSend.apply(this, arguments);
  };
  if ((window.theme && (window.theme.cartCount > 0 || window.theme.pageType === 'cart'))) {
    scheduleSync(600);
  }
})();
